import withToolTip from "components/elements/ToolTip";
import ToolTip from "components/elements/ToolTip";
import { useOutletContext } from "react-router-dom";
const { default: Header } = require("../../common/Header");

const QueryExecutor = () => {
  const token = useOutletContext();
  const { name, client_name } = token;

  return (
    <div id="query-executor" className="page">
      <Header user={name} client_name={client_name} title="Query Executor" />
      <div className="test" style={{ margin: "1rem" }}>
        <ToolTip text="just write something in this input">
          <input type="text" placeholder="Something" />
        </ToolTip>
      </div>
    </div>
  );
};

export default QueryExecutor;
